/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState } from "react";

interface AuthContextType {
  sessionToken: string;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType>({
  sessionToken: "",
  login: async () => {},
  logout: () => {},
});

function getSessionToken() {
  return localStorage.getItem("dealhack-access-token");
}

export function useAuthContext() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [sessionToken, setSessionToken] = useState(getSessionToken() || "");

  async function login(email: string, password: string) {
    // TODO: Implement actual login logic with email and password
    console.log(
      "Login attempt for:",
      email,
      "with password length:",
      password.length
    );
    // For now, just set a dummy token
    setSessionToken("dummy-token");
  }

  async function logout() {
    localStorage.removeItem("dealhack-access-token");
    setSessionToken("");
  }

  return (
    <AuthContext.Provider
      value={{
        sessionToken,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
